import axios from '../../utils/axios2';
import queryString from '../../utils/queryString';


export default {

    namespaced: true,

    state: {
        truckModel: null,
        truckModels: []
    },

    mutations: {
        setTruckModel(state, payload) {
            state.truckModel = payload;
        },
        setTruckModels(state, payload) {
            state.truckModels = payload
        }
    },

    actions: {
        storeTruckModel({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `truck-models`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        updateTruckModel({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `truck-models/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        removeTruckModel({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `truck-models/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        fetchTruckModel({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `truck-models/${payload}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setTruckModel", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        fetchTruckModels({commit, rootState}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `truck-models?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit("setTruckModels", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        }
    }

}